import { render, staticRenderFns } from "./agendaDoctores.vue?vue&type=template&id=16dc7e2e&scoped=true"
import script from "./agendaDoctores.vue?vue&type=script&lang=js"
export * from "./agendaDoctores.vue?vue&type=script&lang=js"
import style0 from "./agendaDoctores.vue?vue&type=style&index=0&id=16dc7e2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc7e2e",
  null
  
)

export default component.exports